// extracted by mini-css-extract-plugin
export default {"list__about":"Misc_list__about__uOcAS","list__contact":"Misc_list__contact__MxF4P","mailto":"Misc_mailto__CWid2"};